import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AccountMarketplace, Marketplace, Strategy } from "@front/m19-api-client";
import { AccountSelectionService } from "@front/m19-services";
import { ICON_CHEVRON_DOWN } from "@m19-board/utils/iconsLabels";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { SdStrategyCreationComponent } from "@m19-board/sponsored-display/sd-manager/sd-strategy-creation/sd-strategy-creation.component";

@UntilDestroy()
@Component({
  template: ` <app-sd-strategy-creation (strategyCreated)="onStrategyCreated($event)"></app-sd-strategy-creation> `,
  styleUrls: ["../../../strategies/strategies/strategy-styles.scss"],
  standalone: true,
  imports: [SdStrategyCreationComponent],
})
export class SdStrategyCreationPageComponent implements OnInit {
  marketplace?: Marketplace;
  readonly ICON_CHEVRON_DOWN = ICON_CHEVRON_DOWN;

  constructor(
    private accountSelection: AccountSelectionService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.accountSelection.singleAccountMarketplaceSelection$
      .pipe(untilDestroyed(this))
      .subscribe((am: AccountMarketplace) => {
        this.marketplace = am.marketplace;
      });
  }

  onStrategyCreated(strategy: Strategy) {
    this.router.navigate(["/advertising/sponsored-display/" + strategy.strategyId], { queryParamsHandling: "merge" });
  }
}
